export interface IFileProps {
  id?: string | null
  path?: string | null
  filename?: string | null
  thumbnail?: boolean | null
  extension?: string | null
  origin?: string | null
  width?: number | null
  height?: number | null
  size?: number | null
  mimetype?: string | null
}

export default class FileEntity {
  private _props: IFileProps

  constructor(props?: IFileProps | null) {
    this._props = EmptyFilePropsFactory(props)
  }

  get props(): IFileProps {
    return this._props
  }

  get clone(): IFileProps {
    return structuredClone(this._props)
  }

  get image(): boolean {
    return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'].includes((this._props.extension || '').toLowerCase())
  }

  get movie(): boolean {
    return ['mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv', 'webm'].includes((this._props.extension || '').toLowerCase())
  }
}

export const EmptyFilePropsFactory = (props?: Partial<IFileProps> | null): IFileProps => ({
  ...props
})
